import $axios from '../../settings/axios.js';
import { staticData } from '@/helper/staticData.js';
//import localizationTexts from '@/localization/texts.json';

const state = {
  app: {
    isAm: false,
    disableApp: false,
    host: '',
    containerId: '',
    price: -1,
    priceError: false,
    loading: true,
    userInfo: {
      consent: false,
      fullName: '',
      phone: '',
      email: '',
      ageRange: '25-29',
      cpr: '',
      comment: '',
      licenseplate: ''
    },
    conditions: {
      lockdownCarPrice: {
        activated: false,
        value: -1
      }
    },
    error: '',
    ins: {
      // insurance collection
      carType: 0,
      carAge: 0,
      newCarPrice: {
        value: null,
        selectedvalue: null,
        title: null
      },
      isElite: true,
      numberOfInjuries: {
        value: null,
        title: null
      },
      age: 25,
      postalCode: 3700,
      includeRoadAssistance: false,
      includeLeasingCoverage: false,
      includeDeductibleCoverage: false,
      selectlicenseFor3Years: false,
       // new insurance props
      driverCoverage: false,
      youngDriver: false,
      glass:false,
      parking:false,

     
      // includeRoadAssistance0To5	:false,
      // includeRoadAssistance6To9	:false,
      // includeRoadAssistance10Plus	:false,
      damageConverage	:false,
      rentalPlus	:false,
      leasingBasis	:false,
      
    },
    insApiCallback: {
      initData: false,
      lasteDate: null,
      state: {
        status: -1,
        msg: null,
        data: {
          carType: 0,
          age: null,
          numberOfAccidents: null,
          newCarPrice: null,
          amount: null,
          baseAmount: null,
          // includeRoadAssistance: null,
          includeLeasingCoverage: null,
          includeDeductibleCoverage: null,
          deductible: 10000,
          includeRoadAssistance0To5:	false,
        includeRoadAssistance6To9	:false,
        includeRoadAssistance10Plus	:false,

        }
      }
    }
  }
};

const getters = {
  app: state => state.app,
  ins: state => state.app.ins
};

const actions = {
  isAm({ commit }, isAm) {
    commit('SET_ISAM', isAm);
  },
  async setPreValuesAndGetPrice({ state, dispatch }) {
    // find last age in staticData.step1.selectDataYourAge array
    const dataYourAge = staticData.step1.selectDataYourAge;
    const age = dataYourAge.find(x=>x.value=='25-29');
    dispatch('age', age); 
    // dispatch('isElite', true);
    if (state.app.conditions.lockdownCarPrice.activated == false) {
      const vehicleNewValue = staticData.step1.selectDataVehicleValueNew[0];
      dispatch('vehicleAndCarTypeValue', vehicleNewValue);
    }
  },
  async getInsurancePrice({ commit, state }) {
    if (
      state.app.ins.age != null &&
      // state.app.ins.numberOfInjuries.value != null &&
      state.app.ins.newCarPrice.value != null
    ) {
      commit('SET_LOADING', true);
      let data = {
        age: state.app.ins.age,
        newCarPrice: state.app.ins.newCarPrice.value,
        carType: state.app.ins.carType,
        includeRoadAssistance: state.app.ins.includeRoadAssistance,
        // includeDeductibleCoverage: state.app.ins.includeDeductibleCoverage,
        // includeLeasingCoverage: state.app.ins.includeLeasingCoverage,

// new insurance props
        driverCoverage: state.app.ins.driverCoverage,
        youngDriver: state.app.ins.youngDriver,
        glass:state.app.ins.glass,
        parking:state.app.ins.parking,
        // includeRoadAssistance0To5	:state.app.ins.includeRoadAssistance0To5,
        // includeRoadAssistance6To9	:state.app.ins.includeRoadAssistance6To9,
        // includeRoadAssistance10Plus	:state.app.ins.includeRoadAssistance10Plus,
        damageConverage	:state.app.ins.damageConverage,
        rentalPlus	:state.app.ins.rentalPlus,
        leasingBasis	:state.app.ins.leasingBasis,

      }
      
      if (state.app.ins.postalCode) {
        data.ZipCode = state.app.ins.postalCode;
      }
      if (state.app.ins.carAge > 0 && state.app.ins.includeRoadAssistance == true) {
        data.carAge = Number.parseInt(state.app.ins.carAge);
      }
      if (state.app.ins.isElite) {
        data.isElite = state.app.ins.isElite;
      }
      

      $axios
        .post('api/insurance/price', data)
        .then(
          response => {
            let messageObj = response.data;
            messageObj.selectlicenseFor3Years =
              state.app.userInfo.ageRange.value != '18-20' && state.app.ins.selectlicenseFor3Years;
            window.parent.postMessage(messageObj, state.app.host);
            
            commit('SET_LOADING', false);

            let data = response.data; 
            data.baseAmount = Math.ceil(data.amount / 12);
            data.totalAmount = Math.ceil(data.totalAmount / 12);


            commit('SET_INSAPICALLBACK', response.data);
            commit('SET_APPERROR', '');
          },
          error => {
            state.app.priceError = true;
            commit('SET_LOADING', false);
            commit('SET_APPERROR', error);
          }
        )
        .catch(function(error) {
          state.app.loading = false;
          commit('SET_APPERROR', error);
        });
    }
  },
  async makeInsuranceOffer({  commit, state }) {
    if (
      state.app.userInfo.fullName != '' &&
      state.app.userInfo.phone != '' &&
      state.app.userInfo.email != '' &&
      state.app.userInfo.consent == true
    ) {
      state.app.loading = true;

      let data = {
        referrer: state.app.host.replace(/^http(s?):\/\//i, '') + '( ' + state.app.host + ' )',
        email: state.app.userInfo.email,
        
        phone: state.app.userInfo.phone,
        fullName: state.app.userInfo.fullName,
        consent: state.app.userInfo.consent,
        age: state.app.userInfo.ageRange.title,
        cpr: state.app.userInfo.cpr,
        comment: state.app.userInfo.comment,
        licenseplate: state.app.userInfo.licenseplate,
        newCarPrice: state.app.ins.newCarPrice.title,
        carType: state.app.ins.carType,
        monthlyPrice: state.app.price,
        postalCode: state.app.ins.postalCode,
        deductible: state.app.insApiCallback.state.data.deductible,



        // includeRoadAssistance: state.app.ins.includeRoadAssistance,

        // includeDeductibleCoverage: state.app.ins.includeDeductibleCoverage,
        // includeLeasingCoverage: state.app.ins.includeLeasingCoverage,
        // licenseFor3Years: state.app.ins.selectlicenseFor3Years,



        driverCoverage: state.app.insApiCallback.state.data.driverCoverage,
        youngDriver: state.app.insApiCallback.state.data.youngDriver,
        glass:state.app.insApiCallback.state.data.glass,
        parking:state.app.insApiCallback.state.data.parking,



        includeRoadAssistance0To5	:    state.app.insApiCallback.state.data.includeRoadAssistance0To5,
        includeRoadAssistance6To9	:   state.app.insApiCallback.state.data.includeRoadAssistance6To9,
        includeRoadAssistance10Plus	: state.app.insApiCallback.state.data.includeRoadAssistance10Plus,

        damageConverage	:state.app.insApiCallback.state.data.damageConverage,
        rentalPlus	:state.app.insApiCallback.state.data.rentalPlus,
        leasingBasis	:state.app.insApiCallback.state.data.leasingBasis,
      }
      if (state.app.ins.carAge > 0 && state.app.ins.includeRoadAssistance == true) {
        data.carAge =Number.parseInt(state.app.ins.carAge);
      }
      if (state.app.ins.isElite) {
        data.isElite = state.app.ins.isElite;
      }
      try{


      $axios({
          method: 'post',
          url: 'api/insurance/offer',
          data: JSON.stringify(data),
          config: { 
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json' 
            }
          }
        })

        // .post('/api/insurance/offer', data)
        .then(
          () => {
            state.app.loading = false;

            const dataLayerData = {
              event: 'technoforsikring-event',
              category: 'insuranceoffer',
              action: 'offer send',
              value: true,
              parentHostName: state.app.host || 'undefined'
            };

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(dataLayerData);

            parent.postMessage({ action: 9, namespace: 'bt', data: dataLayerData }, state.app.host);

            commit('SET_APPERROR', '');
          },
          error => {
            state.app.loading = false;
            commit('SET_APPERROR', error);
          }
        )
        .catch(function(error) {
          state.app.loading = false;
          commit('SET_APPERROR', error);
        });

        } catch(e) {
          state.app.loading = false;
          commit('SET_APPERROR', e);
        }

    }
  },
  carAgeChange({ commit }, payload) {
    commit('SET_carAge', payload);
  },
  setHost({ commit }, payload) {
    commit('SET_SETHOST', payload);
  },
  setContainerId({ commit }, payload) {
    commit('SET_CONTAINERID', payload);
  },
  disableAppFromSettings({ commit }, payload) {
    commit('SET_DISABLEAPPFROMSETTINGS', payload);
  },
  conditionslockdownCarPrice({ commit, dispatch }, payload) {
    commit('SET_CONDITIONSLOCKDOWNCARPRICE', {
      activated: payload.activated,
      value: payload.value
    });
    dispatch('vehicleAndCarTypeValue', payload.cartype);
  },
  loading({ commit }, payload) {
    commit('SET_LOADING', payload);
  },
  insApiCallback({ commit }, payload) {
    commit('SET_INSAPICALLBACK', payload);
  },
  age({ commit }, payload) {
    commit('SET_AGE', payload);
  },
  postalCode({ commit }, payload) {
    commit('SET_postalCode', payload);
  },
  selectlicenseFor3Years({ commit }, payload) {
    commit('SET_SELECTLICENSEFOR3YEARS', payload);
  },
  isElite({ commit }, payload) {
    commit('SET_isElite', payload);
  },
  vehicleAndCarTypeValue({ commit }, payload) {
    if (payload.value.startsWith('van')) {
      commit('SET_VEHICLEANDCARTYPEVALUE', {
        value: payload.value.replace('van-', ''),
        selectedvalue: payload.value,
        title: payload.title,
        carType: 1
      });
    } else {
      commit('SET_VEHICLEANDCARTYPEVALUE', {
        value: payload.value,
        selectedvalue: payload.value,
        title: payload.title,
        carType: 0
      });
    }
  },
  vehicleValue({ commit }, payload) {
    commit('SET_VEHICLEVALUE', isNaN(payload) ? null : parseInt(payload));
  },
  carType({ commit }, payload) {
    commit('SET_CARTYPE', isNaN(payload) ? null : parseInt(payload));
  },
  includeRoadAssistance({ commit }, payload) {
    commit('SET_INCLUDEROADASSISTANCE', payload);
  },

  includeDeductibleCoverage({ commit }, payload) {
    commit('SET_INCLUDEDEDUCTIBLECOVERAGE', payload);
  },
  checkboxListChange({ commit }, payload) {
    commit('SET_CHECKBOXLISTCHANGE', payload);
  },
  // extendedCoverage({ commit }, payload) {
  //   commit('SET_EXTENDEDCOVERAGE', payload);
  // },
  includeLeasingCoverage({ commit }, payload) {
    commit('SET_INCLUDELEASINGCOVERAGE', payload);
  },
  // parkingDamageCoverage({ commit }, payload) {
  //   commit('SET_PARKINGDAMAGECOVERAGE', payload);
  // },

  // user info
  nameChange({ commit }, payload) {
    commit('SET_NAMECHANGE', payload);
  },
  telephoneChange({ commit }, payload) {
    commit('SET_TELEPHONECHANGE', payload);
  },
  emailChange({ commit }, payload) {
    commit('SET_EMAILCHANGE', payload);
  },
  acceptTermsChange({ commit }, payload) {
    commit('SET_ACCEPTTERMSCHANGE', payload);
  },
  cprChange({ commit }, payload) {
    commit('SET_CPR', payload);
  },
  commentChange({ commit }, payload) {
    commit('SET_COMMENT', payload);
  },
  licenseplateChange({ commit }, payload) {
    commit('SET_LICENSEPLATE', payload);
  }
};
const mutations = {
  SET_ISAM(state , payload) {
    state.app.isAM = payload;
  },
  SET_INSAPICALLBACK(state, payload) {
    if (payload != null) {
      state.app.price = payload.totalAmount;
      state.app.priceError = false;
    } else {
      state.app.priceError = true;
    }
    state.app.insApiCallback.state.data = payload;
    state.app.insApiCallback.lasteDate = new Date();
    state.app.insApiCallback.initData = true;
  },
  SET_LOADING(state, payload) {
    state.app.loading = payload;
  },
  SET_CONDITIONSLOCKDOWNCARPRICE(state, payload) {
    state.app.conditions.lockdownCarPrice = payload;
  },
  SET_SELECTLICENSEFOR3YEARS(state, payload) {
    state.app.ins.selectlicenseFor3Years = payload;
  },
  SET_isElite(state, payload) {
    state.app.ins.isElite = payload;
  },
  SET_VEHICLEANDCARTYPEVALUE(state, payload) {
    state.app.ins.newCarPrice.value = isNaN(payload.value) ? null : parseInt(payload.value);
    state.app.ins.newCarPrice.selectedvalue = payload.selectedvalue;
    state.app.ins.newCarPrice.title = payload.title;
    state.app.ins.carType = isNaN(payload.carType) ? null : parseInt(payload.carType);
  },
  SET_AGE(state, payload) {
    if (payload.value.includes('-')) {
      state.app.ins.age = isNaN(payload.value.substring(3))
        ? null
        : parseInt(payload.value.substring(3));
    } else {
      state.app.ins.age = isNaN(payload.value) ? null : parseInt(payload.value);
    }
    state.app.userInfo.ageRange = payload;
  },
  SET_YEARSWITHOUTDAMAGE(state, payload) {
    state.app.ins.numberOfInjuries = {
      value: isNaN(payload.value) ? null : parseInt(payload.value),
      title: payload.title
    };
  },
  SET_VEHICLEVALUE(state, payload) {
    state.app.ins.newCarPrice = isNaN(payload) ? null : parseInt(payload);
  },
  SET_postalCode(state, payload) {
    state.app.ins.postalCode = isNaN(payload) ? null : parseInt(payload);
  },
  SET_CARTYPE(state, payload) {
    state.app.ins.carType = isNaN(payload) ? null : parseInt(payload);
  },
  SET_INCLUDEROADASSISTANCE(state, payload) {
    state.app.ins.includeRoadAssistance = payload;
  },
  // SET_PARKINGDAMAGECOVERAGE(state, payload) {
  //   state.app.ins.parkingDamageCoverage = payload;
  // },
  SET_INCLUDEDEDUCTIBLECOVERAGE(state, payload) {
    state.app.ins.includeDeductibleCoverage = payload;
  }, 
  SET_CHECKBOXLISTCHANGE(state, payload) {




    state.app.ins[payload.key] = payload.value;


  },
  SET_INCLUDELEASINGCOVERAGE(state, payload) {
    state.app.ins.includeLeasingCoverage = payload;
  },

  SET_TELEPHONECHANGE(state, payload) {
    state.app.userInfo.phone = payload;
  },
  SET_NAMECHANGE(state, payload) {
    state.app.userInfo.fullName = payload;
  },
  SET_ACCEPTTERMSCHANGE(state, payload) {
    state.app.userInfo.consent = payload;
  },
  SET_EMAILCHANGE(state, payload) {
    state.app.userInfo.email = payload;
  },
  SET_SETHOST(state, payload) {
    state.app.host = payload;
  }, 
  SET_carAge(state, payload) {
    state.app.ins.carAge = payload;
  },
  SET_CONTAINERID(state, payload) {
    state.app.containerId = payload;
  },
  SET_DISABLEAPPFROMSETTINGS(state, payload) {
    state.app.disableApp = payload;
  },
  SET_APPERROR(state, payload) {
    state.app.error = payload;
  },
  SET_CPR(state, payload) {
    state.app.userInfo.cpr = payload;
  },
  SET_LICENSEPLATE(state, payload) {
    state.app.userInfo.licenseplate = payload;
  },
  SET_COMMENT(state, payload) {
    state.app.userInfo.comment = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
